<div class="loading">
	<div class="loader">
		<div class="innerLoder one"></div>
		<div class="innerLoder two"></div>
		<div class="innerLoder three"></div>

	</div>
</div>